var _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerticalEllipsis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 4.66699,
    r: 2,
    transform: "rotate(90 10 4.66699)",
    fill: "#899AA3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 2,
    transform: "rotate(90 10 10)",
    fill: "#899AA3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 15.333,
    r: 2,
    transform: "rotate(90 10 15.333)",
    fill: "#899AA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalEllipsis);
export default __webpack_public_path__ + "static/media/vertical_ellipsis.06f3f1625f1ce078bccbdf8a8626a85b.svg";
export { ForwardRef as ReactComponent };